import React, { useEffect, useRef, useState } from 'react';
import './rotuesOverview.scss';
import { IUser } from '../../models';
import PaneHeadline from '../shared/paneHeadline';
import { faRoute } from '@fortawesome/free-solid-svg-icons';
import { IRouteOverview } from '../../models/RouteOverview';
import { Spinner2 } from '../shared/spinner2';
import RoutesOverviewTabGrid from './RoutesOverviewGrid';
import RoutesOverviewModal from './RoutesOverviewModal';
import { locale } from '../../common/localization/localizationService';
import { ExcelExport } from '@progress/kendo-react-excel-export';
import { NavLink } from 'react-router-dom';
import routes from '../../common/routes';

export interface IRoutesOverviewProps {
  impersonatedUser: any;
  authentication: IUser;
  isLoading: boolean;
  loadRoutes: (ignoreCache: boolean) => Promise<void>;
  routesOverview: Array<IRouteOverview>;
}

export default function RoutesOverview(
  props: IRoutesOverviewProps,
): JSX.Element {
  const customerId = props.authentication.impersonatedCustomerId
    ? props.authentication.impersonatedCustomerId
    : props.authentication.customerId;

  useEffect(() => {
    props.loadRoutes(true);
  }, []);

  const [showModal, setShowModal] = useState(false);
  const [selectedRoute, setSelectedRoute] = useState(null);

  const editRoute = (route: IRouteOverview) => {
    setSelectedRoute(route);
    setShowModal(true);
  };

  const openNewRouteModal = () => {
    setSelectedRoute(null);
    setShowModal(true);
  };

  const hideRouteAdministrationModal = (rerender: boolean) => {
    setShowModal(false);
    setSelectedRoute(null);
    if (rerender) {
      props.loadRoutes(true);
    }
  };

  const excelExportRef = useRef<ExcelExport | null>(null);

  const routeIds = props.routesOverview.map((r) => r.route);

  return (
    <>
      <div className="route-administration-tab">
        <div className="route-administration-tab-header-row row">
          <PaneHeadline
            titleText={locale.routeOverview._routeOverview}
            titleIcon={faRoute}
            className="route-overview-header-element"
          />
          <div className="route-overview-header-element text-right mb-3">
            <NavLink
              to={routes.importRoutesWizard}
              className="btn btn-outline-dark import-routes-button"
            >
              {locale.routeOverview._importRouteStops}
            </NavLink>
            <button
              className="btn btn-outline-dark"
              onClick={() => openNewRouteModal()}
            >
              {locale.routeOverview._newRoute}
            </button>
          </div>
          <Spinner2 show={props.isLoading} />
          <div className="routes-overview-tab-content">
            <RoutesOverviewTabGrid
              data={props.routesOverview}
              editRoute={editRoute}
              excelRef={excelExportRef}
            />
          </div>
          {showModal && (
            <RoutesOverviewModal
              customerId={customerId}
              onHide={hideRouteAdministrationModal}
              show={showModal}
              route={selectedRoute}
              routeIds={routeIds}
            />
          )}
        </div>
      </div>
    </>
  );
}
